import { render } from "./LandingPageAttribution.vue?vue&type=template&id=579fa2ce&scoped=true"
import script from "./LandingPageAttribution.vue?vue&type=script&lang=js"
export * from "./LandingPageAttribution.vue?vue&type=script&lang=js"

import "./LandingPageAttribution.vue?vue&type=style&index=0&id=579fa2ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579fa2ce"]])

export default __exports__